import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserTemplateSearchText = createSelector(
  [(store: RootState) => store.templateList.userTemplateSearchText],
  (data) => data
);
